<template>
  <div>
    <h2>
      Dossier d'information Euro-Pharmat <br />
      Dispositif Médical
    </h2>
    <v-container>
      <v-row justify="space-around">
        <v-card v-if="produit" class="produitdarken1" id="ficheDM">
          <v-card-title class="justify-center white--text">{{
            produit.denominationCommerciale
          }}</v-card-title>
          <v-card-subtitle class="text-right white--text">
            <p>
              <v-icon color="white">mdi-calendar-sync</v-icon>
              <span data-testid="dateMaj">{{
                produit.dateMaj | shortDateFr
              }}</span>
            </p>
          </v-card-subtitle>
          <v-expansion-panels
            v-model="panels"
            flat
            tile
            accordion
            multiple
            class="white--text"
          >
            <!-- 1. Renseignements administratifs concernant l'entreprise-->
            <v-expansion-panel>
              <v-expansion-panel-header
                color="produitdarken1"
                class="white--text"
              >
                <v-row>
                  <v-col>
                    <h3>
                      1. Renseignements administratifs concernant l'entreprise
                    </h3>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content v-if="fournisseur" class="ma-0">
                <info-row numero="1.1" intitule="Nom">
                  {{ fournisseur.nom }}
                </info-row>
                <info-row numero="1.2" intitule="Adresse">
                  {{ fournisseur.adresseSiege.ligne1 }}
                  <br v-if="fournisseur.adresseSiege.ligne2" />{{
                    fournisseur.adresseSiege.ligne2
                  }}
                  <br />
                  {{ fournisseur.adresseSiege.codePostal }}
                  {{ fournisseur.adresseSiege.ville }}
                </info-row>
                <info-row intitule="Téléphone">
                  {{ fournisseur.adresseSiege.telephone || "Non renseigné" }}
                </info-row>
                <info-row intitule="Fax">
                  {{ fournisseur.adresseSiege.fax || "Non renseigné" }}
                </info-row>
                <info-row intitule="Email">
                  <span v-if="fournisseur.adresseEmail">
                    <a :href="'mailto:' + fournisseur.adresseEmail"></a>
                    {{ fournisseur.adresseEmail }}
                  </span>
                  <span v-else> Non renseigné </span>
                </info-row>
                <info-row intitule="Site">
                  <span v-if="fournisseur.urlSiteWeb">
                    <a :href="fournisseur.urlSiteWeb">
                      {{ fournisseur.urlSiteWeb }}
                    </a>
                  </span>
                  <span v-else> Non renseigné </span>
                </info-row>
                <info-row intitule="Division">
                  {{ produit.divisionFournisseur || "Non renseigné" }}
                </info-row>
                <info-row
                  numero="1.3"
                  intitule="Correspondant matério-vigilance"
                >
                  {{
                    fournisseur.responsableMaterioVigilance
                      ? fournisseur.responsableMaterioVigilance.nom
                      : "Non renseigné"
                  }}
                </info-row>
                <info-row intitule="Téléphone">
                  {{
                    fournisseur.responsableMaterioVigilance
                      ? fournisseur.responsableMaterioVigilance.telephone
                      : "Non renseigné"
                  }}
                </info-row>
                <info-row intitule="Fax">
                  {{
                    fournisseur.responsableMaterioVigilance
                      ? fournisseur.responsableMaterioVigilance.fax
                      : "Non renseigné"
                  }}
                </info-row>
                <info-row intitule="Email">
                  <span
                    v-if="
                      fournisseur.responsableMaterioVigilance &&
                      fournisseur.responsableMaterioVigilance.adresseEmail
                    "
                  >
                    <a
                      :href="
                        'mailto:' +
                        fournisseur.responsableMaterioVigilance.adresseEmail
                      "
                    >
                      {{ fournisseur.responsableMaterioVigilance.adresseEmail }}
                    </a>
                  </span>
                  <span v-else> Non renseigné </span>
                </info-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!--2. Informations sur dispositif ou équipement-->
            <v-expansion-panel>
              <v-expansion-panel-header
                color="produitdarken1"
                class="white--text"
              >
                <v-row>
                  <v-col>
                    <h3>2. Informations sur dispositif ou équipement</h3>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <info-row
                  numero="2.1"
                  intitule="Dénomination commune selon la nomenclature Euro-Pharmat"
                >
                  {{ produit.libelleDenominationCommune || "Non renseigné" }}
                </info-row>
                <info-row numero="2.2" intitule="Dénomination commerciale">
                  {{ produit.denominationCommerciale }}
                </info-row>
                <info-row numero="2.3" intitule="Code nomenclature (GMDN)">
                  {{ produit.codeProduit || "Non renseigné" }}
                </info-row>
                <info-row intitule="Code EMDN (ou Cladimed phase transitoire)">
                  {{ produit.cladimedPro || "Non renseigné" }}
                </info-row>
                <info-row numero="2.4">
                  <template v-slot:intitule>
                    Code LPP (Liste des produits et prestations) si applicable
                    <br />
                  </template>
                  {{ produit.codeLpp || "Non renseigné" }}
                </info-row>
                <info-row numero="2.5" intitule="Classe du DM">
                  {{ produit.classeDm || "Non renseigné" }}
                </info-row>
                <info-row intitule="Disposition réglementaire">
                  {{ produit.marquageCe || "Non renseigné" }}
                </info-row>
                <info-row intitule="N° de l'organisme notifié">
                  {{ produit.organismeCe || "Non renseigné" }}
                </info-row>
                <info-row intitule="Première mise sur le marché dans l'UE">
                  {{ produit.dateCommercialisation | shortDateFr }}
                </info-row>
                <info-row intitule="Fabricant">
                  {{ produit.fabricant || "Non renseigné" }}
                </info-row>
                <info-row intitule="Statut du fournisseur">
                  {{ produit.statutFournisseur || "Non renseigné" }}
                </info-row>

                <info-row
                  numero="2.6"
                  intitule="Descriptif du dispositif"
                  style="white-space: pre-line"
                >
                  {{ produit.descriptif || "Non renseigné" }}

                  <v-carousel
                    v-if="imagesDescriptif.length"
                    hide-delimiters
                    height="auto"
                    style="text-align: center"
                    :show-arrows="imagesDescriptif.length > 1"
                  >
                    <v-carousel-item
                      v-for="(img, i) in imagesDescriptif"
                      :key="i"
                    >
                      <img
                        :src="imagesPath + img.fichier"
                        :alt="img.intitule"
                        style="margin-bottom: 3em"
                      />
                    </v-carousel-item>
                  </v-carousel>
                </info-row>
                <info-row
                  numero="2.7"
                  :titreSeul="true"
                  intitule="Références catalogue"
                ></info-row>
                <info-row :valeurSeule="true">
                  <v-simple-table
                    dense
                    v-if="references.length > 0"
                    id="references"
                  >
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Intitulé</th>
                          <th class="text-left">
                            UI
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="produit"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-message-question
                                </v-icon>
                              </template>
                              <span
                                >Unité intègre (plus petite unité d'emploi non
                                divisible)</span
                              >
                            </v-tooltip>
                            <v-chip
                              x-small
                              color="produit"
                              text-color="white"
                              style="font-size: 0.8em"
                              ><v-icon left x-small v-bind="attrs" v-on="on">
                                mdi-tag </v-icon
                              >IUD-ID
                            </v-chip>
                          </th>
                          <th class="text-left">
                            CDT
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="produit"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-message-question
                                </v-icon>
                              </template>
                              <span>Unité de commande commerciale</span>
                            </v-tooltip>
                            <v-chip
                              x-small
                              color="produit"
                              text-color="white"
                              style="font-size: 0.8em"
                              ><v-icon left x-small v-bind="attrs" v-on="on">
                                mdi-tag </v-icon
                              >IUD-ID
                            </v-chip>
                          </th>
                          <th class="text-left">
                            QML
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="produit"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-message-question
                                </v-icon>
                              </template>
                              <span>Quantité Minimale de Livraison</span>
                            </v-tooltip>
                          </th>
                          <th class="text-left">Descriptif</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="ref in references" :key="ref.id">
                          <td>{{ ref.intitule }}</td>
                          <td>
                            {{ ref.conditionnementEmploi }}
                            <span
                              v-if="ref.iudIdEmploi"
                              style="font-size: 0.8em"
                            >
                              <v-chip
                                x-small
                                color="produit"
                                text-color="white"
                              >
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      left
                                      x-small
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      mdi-tag
                                    </v-icon>
                                  </template>
                                  <span>IUD-ID</span>
                                </v-tooltip>
                                {{ ref.iudIdEmploi }}
                              </v-chip>
                            </span>
                          </td>
                          <td>
                            {{ ref.quantiteEmploi }} par
                            {{ ref.conditionnementProtege }}
                            <span
                              v-if="ref.iudIdProtege"
                              style="font-size: 0.8em"
                            >
                              <v-chip
                                x-small
                                color="produit"
                                text-color="white"
                              >
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      left
                                      x-small
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      mdi-tag
                                    </v-icon>
                                  </template>
                                  <span>IUD-ID</span>
                                </v-tooltip>
                                {{ ref.iudIdProtege }}
                              </v-chip>
                            </span>
                          </td>
                          <td>
                            {{ ref.quantiteCommande }}
                            UI
                          </td>
                          <td>
                            {{ ref.descriptif }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <v-carousel
                    v-if="imagesReferences.length"
                    hide-delimiters
                    height="auto"
                    style="text-align: center"
                    :show-arrows="imagesReferences.length > 1"
                  >
                    <v-carousel-item
                      v-for="(img, i) in imagesReferences"
                      :key="i"
                    >
                      <img
                        :src="imagesPath + img.fichier"
                        :alt="img.intitule"
                        style="margin-bottom: 3em"
                      />
                    </v-carousel-item>
                  </v-carousel>
                </info-row>
                <info-row
                  numero=" 2.8"
                  :titreSeul="true"
                  intitule="Composition du dispositif et accessoires"
                >
                </info-row>
                <info-row
                  :titreSeul="true"
                  intitule="Principaux composants et matériaux"
                ></info-row>
                <info-row :valeurSeule="true">
                  <ul>
                    <li
                      v-for="elt in elements"
                      :key="elt.element + elt.materiau"
                    >
                      {{ elt.element }}
                      <span v-if="elt.element && elt.materiau">-</span>
                      {{ elt.materiau }}
                    </li>
                  </ul>
                </info-row>
                <info-row
                  :titreSeul="true"
                  intitule="Substances actives"
                ></info-row>
                <info-row :valeurSeule="true">
                  <ul>
                    <li v-for="subst in substances" :key="subst.id">
                      {{ subst.libelle }}
                    </li>
                  </ul>
                </info-row>
                <info-row
                  :titreSeul="true"
                  intitule="Pour les composants suceptibles d'entrer en contact avec le patient et/ou les produits administrés,
              précisions complémentaires"
                ></info-row>
                <info-row intitule="Latex">{{ produit.avecLatex }}</info-row>
                <info-row intitule="Phtalates">{{
                  produit.avecPhtalates || "Non renseigné"
                }}</info-row>
                <info-row intitule="Origine animale ou biologique">{{
                  produit.origineAnimaleOuBiologique || "Non renseigné"
                }}</info-row>
                <info-row intitule="Pertubateurs endocriniens">{{
                  produit.pertubateursEndocriniens || "Non renseigné"
                }}</info-row>
                <info-row
                  intitule="Substances cancérogènes, mutagènes et reprotoxiques (CMR)"
                  >{{
                    produit.substancesCancerogenes || "Non renseigné"
                  }}</info-row
                >
                <info-row intitule="IRM compatibilité">{{
                  produit.irmCompatibilite || "Non renseigné"
                }}</info-row>
                <info-row intitule="Autres composants">{{
                  produit.autresComposants || "Non renseigné"
                }}</info-row>
                <info-row
                  :titreSeul="true"
                  intitule="Dispositifs et accessoires associés (consommables captifs notamment)"
                >
                </info-row>
                <info-row :valeurSeule="true">
                  {{
                    produit.dispositifEtAccessoiresAssocies || "Non renseigné"
                  }}
                </info-row>
                <info-row
                  numero="2.9"
                  :titreSeul="true"
                  intitule="Domaines (selon nomenclature Euro-Pharmat)"
                ></info-row>
                <info-row :valeurSeule="true">
                  <ul class="pl-0">
                    <li v-for="domaine in domaines" :key="domaine.id">
                      {{ domaine.libelle }}
                    </li>
                  </ul>
                </info-row>
                <info-row
                  numero="2.10"
                  intitule="Indications (selon notice d'utilisation)"
                  >{{ produit.indicationsNotice || "Non renseigné" }}</info-row
                >
                <info-row intitule="Destination (selon marquage CE)">{{
                  produit.indicationsTexte || "Non renseigné"
                }}</info-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- 3. Procédés de stérilisation-->
            <v-expansion-panel>
              <v-expansion-panel-header
                color="produitdarken1"
                class="white--text"
              >
                <v-row>
                  <v-col>
                    <h3>3. Procédés de stérilisation</h3>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <info-row :valeurSeule="true">
                  <v-checkbox
                    label="Produit stérile"
                    v-model="produit.sterile"
                    disabled
                  ></v-checkbox>
                </info-row>
                <info-row :valeurSeule="true">
                  <ul>
                    <li v-for="st in sterilisations" :key="st.id">
                      {{ st.libelle }}
                      <span v-if="st.tauxResiduel">
                        (Taux résiduel: {{ st.tauxResiduel }})
                      </span>
                    </li>
                  </ul>
                </info-row>
                <info-row intitule="DM à usage unique">
                  {{ produit.usageUnique || "Non renseigné" }}
                </info-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- 4. Conditions de conservation-->
            <v-expansion-panel>
              <v-expansion-panel-header
                color="produitdarken1"
                class="white--text"
              >
                <v-row>
                  <v-col>
                    <h3>4. Conditions de conservation</h3>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <info-two-rows
                  intitule="Conditions normales de conservation et de stockage"
                  :valeur="produit.conditionsConservation || 'Non renseigné'"
                ></info-two-rows>
                <info-two-rows
                  intitule="Précautions particulières"
                  :valeur="produit.precautions || 'Non renseigné'"
                >
                </info-two-rows>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- 5. Documents annexés au dossier DM-->
            <v-expansion-panel>
              <v-expansion-panel-header
                color="produitdarken1"
                class="white--text"
              >
                <v-row>
                  <v-col>
                    <h3>5. Documents annexés au dossier DM</h3>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <info-row :valeurSeule="true">
                  <ul>
                    <li v-for="doc in documents" :key="doc.id">
                      <a :href="pdfPath + doc.fichier">
                        {{ doc.typeDocument }}
                        <span v-if="doc.intitule"> - {{ doc.intitule }}</span>
                        <span v-if="doc.taille"> ({{ doc.taille }})</span>
                      </a>
                    </li>
                  </ul>
                </info-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- 6. Images (photos, étiquettes...)-->
            <v-expansion-panel>
              <v-expansion-panel-header
                color="produitdarken1"
                class="white--text"
              >
                <h3>6. Images (photos, étiquettes...)</h3>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <info-row :valeurSeule="true">
                  <v-carousel
                    v-if="images.length"
                    cycle
                    height="auto"
                    style="text-align: center"
                    :hide-delimiters="images.length < 2"
                    :show-arrows="images.length > 1"
                  >
                    <v-carousel-item v-for="(img, i) in images" :key="i">
                      <img
                        :src="imagesPath + img.fichier"
                        :alt="img.intitule"
                        style="margin-bottom: 3em"
                      />
                    </v-carousel-item>
                  </v-carousel>
                </info-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-row>
      <v-row class="justify-center">
        <v-col class="mt-4 my-2 text-center">
          <v-btn
            color="produit"
            class="white--text"
            @click="getPdf(produit.id)"
          >
            <v-icon color="white">mdi-printer</v-icon>&nbsp;Edition
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ProduitService from "@/services/ProduitsService";
import InfoRow from "@/components/InfoFicheDM.vue";
import InfoTwoRows from "@/components/InfoFicheDmDeuxLignes";

export default {
  name: "ProduitView",
  components: {
    InfoRow,
    InfoTwoRows,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      produit: null,
      fournisseur: null,
      references: "",
      elements: "",
      indications: "",
      domaines: "",
      substances: "",
      sterilisations: "",
      images: "",
      imagesDescriptif: "",
      imagesReferences: "",
      documents: "",
      panels: [0, 1, 2, 3, 4, 5, 6, 7, 8],
    };
  },
  computed: {
    imagesPath() {
      return process.env.VUE_APP_PATH_TO_PDT_IMAGES;
    },
    pdfPath() {
      return process.env.VUE_APP_PATH_TO_PDF;
    },
  },
  methods: {
    retourLigneDescIndent(val) {
      let retour = val.replace(/\r/g, "<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;");
      return retour;
    },
    getPdf(id) {
      // console.log(id);
      ProduitService.getFicheDmPdf(id).then((response) => {
        let blob = new Blob([response.data], { type: "application/pdf" });
        let url = window.URL.createObjectURL(blob);
        window.open(url);
      });
    },
  },
  created() {
    // Obtient les données à afficher
    let id = this.id;
    ProduitService.getProduit(id)
      .then((res) => {
        this.produit = res.data;

        this.$store.dispatch("setInfosFicheDM", {
          nomProduit: this.produit.denominationCommerciale,
        });

        Promise.all([
          ProduitService.getFournisseurProduit(id),
          ProduitService.getReferencesProduit(id),
          ProduitService.getElementsProduit(id),
          ProduitService.getDomainesProduit(id),
          ProduitService.getIndicationsProduit(id),
          ProduitService.getSterilisationsProduit(id),
          ProduitService.getSubstancesProduit(id),
          ProduitService.getDocumentsProduit(id),
          ProduitService.getImagesProduit(id),
        ]).then((res) => {
          this.fournisseur = res[0].data;
          this.references = res[1].data;
          this.elements = res[2].data;
          this.domaines = res[3].data;
          this.indications = res[4].data;
          this.sterilisations = res[5].data;
          this.substances = res[6].data;
          this.documents = res[7].data;
          this.images = res[8].data;
          // Réaffectation des images selon destination
          let imgsIndexToRemove = [];
          this.imagesDescriptif = [];
          this.imagesReferences = [];
          this.images.forEach((img, index) => {
            if (img.position == "description") {
              this.imagesDescriptif.push(img);
              imgsIndexToRemove.push(index);
            } else if (img.position == "references") {
              this.imagesReferences.push(img);
              imgsIndexToRemove.push(index);
            }
          });
          imgsIndexToRemove
            .sort((a, b) => b - a)
            .forEach((ind) => {
              this.images.splice(ind, 1);
            });
        });
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style scoped>
h2 {
  font-size: 1em;
  text-align: center;
  color: var(--v-produit-darken1);
  font-weight: bold;
  margin-bottom: 1em;
}

#ficheDM >>> .v-expansion-panel-header__icon > .v-icon {
  color: #fff;
}

#ficheDM >>> .v-expansion-panel-content__wrap {
  padding: 0 12px;
}

.v-card {
  font-size: 0.9em;
}

h3 {
  font-size: 0.95em;
}

li {
  list-style: none;
}

.ref-titre {
  font-weight: bold;
}

.ref {
  background-color: var(--v-produitlighten5-base);
  font-weight: normal;
}

#references tr td {
  font-weight: normal;
  background: var(--v-produitlighten5-base);
}
#references tr th {
  color: var(--v-produit-base);
  background: var(--v-produitlighten5-darken1);
}
</style>
